import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// PWA service worker.
// In PRODUCTION: register /service-worker.js and reload when it broadcasts SW_UPDATED
//   (so a new deploy is visible without a manual hard-refresh).
// In DEVELOPMENT (preview builds): forcibly UNREGISTER any lingering SW from a prior
//   visit and delete all its caches — otherwise a stale prod SW keeps serving the OLD
//   bundle and users report "I can't see the latest changes on preview".
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    if (process.env.NODE_ENV === "production") {
      navigator.serviceWorker
        .register("/service-worker.js")
        .catch((err) => console.warn("SW registration failed", err));
      // If the SW broadcasts an update, reload once so the new bundle is picked up.
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data?.type === "SW_UPDATED" && !window.__swReloaded) {
          window.__swReloaded = true;
          window.location.reload();
        }
      });
    } else {
      // Dev / preview: purge any legacy service worker + its caches ONCE per session
      // (sessionStorage flag prevents an infinite reload loop if the browser
      // re-registers the SW between unregister-call and page reload).
      if (sessionStorage.getItem("__swPurged") === "1") return;
      navigator.serviceWorker.getRegistrations().then((regs) => {
        if (regs.length > 0) {
          sessionStorage.setItem("__swPurged", "1");
          Promise.all(regs.map((r) => r.unregister())).then(() => {
            if (window.caches?.keys) {
              caches.keys().then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
                .then(() => window.location.reload());
            } else {
              window.location.reload();
            }
          });
        }
      }).catch(() => null);
    }
  });
}
